import axios from 'axios'

const API_BASE_URL = '/api'

const surpriseBagApi = axios.create({
  baseURL: `${API_BASE_URL}/offers`,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Add request interceptor for authentication
surpriseBagApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Add response interceptor for error handling
surpriseBagApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('access_token')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

export interface SurpriseBagStats {
  total_surprise_bags: number
  active_surprise_bags: number
  total_reveals: number
  average_savings_percentage: number
  most_common_contents: Array<{ item: string; count: number }>
  by_merchant: Array<{
    merchant_name: string
    count: number
    total_reveals: number
  }>
  monthly_trend: Array<{
    month: string
    created: number
    revealed: number
  }>
}

export const surpriseBagService = {
  async getSurpriseBags(filters?: { merchant_id?: string; is_active?: boolean }) {
    const params = new URLSearchParams()
    if (filters?.merchant_id) params.append('merchant_id', filters.merchant_id)
    if (filters?.is_active !== undefined) params.append('is_active', String(filters.is_active))
    params.append('type', 'surprise_bag')

    const response = await surpriseBagApi.get('', { params })
    return response.data
  },

  async getSurpriseBagStats(): Promise<SurpriseBagStats> {
    const response = await surpriseBagApi.get('/stats/surprise-bags')
    return response.data
  },

  async getSurpriseBagById(id: string) {
    const response = await surpriseBagApi.get(`/${id}`)
    return response.data
  },

  async revealSurpriseBagContents(reservationId: string) {
    const response = await surpriseBagApi.post(`/reservations/${reservationId}/reveal-contents`)
    return response.data
  },
}

export default surpriseBagService
